import React from "react";

const ImageWrapper = ({imageUrl, imageName, className, onImageClicked}) => {
  return <div className="overflow-hidden bg-gray-100 w-28 h-14 rounded-md shrink-0 cursor-pointer"
              onClick={onImageClicked}>
    <img className="object-cover w-full h-full" src={imageUrl} alt={imageName ?? "images"}/>
  </div>

}
export const Avatar = ({imageUrl, imageName, className}) => {
  return <div className={`${className ? className : ""} w-12 h-12 rounded-full overflow-hidden bg-gray-100 shrink-0`}>
    <img className="object-cover w-full h-full" src={imageUrl} alt={imageName ?? "images"}/>
  </div>

}
export default ImageWrapper
